export default __webpack_public_path__ + "static/media/infopszcz.2fe1a681.svg";